import {Question} from 'Event/Question'
import {Form} from 'organization/Event/FormsProvider'
import React, {Dispatch, SetStateAction, useEffect} from 'react'
import {useCheckQuestionRules} from 'Event/Question/use-is-visible-question'
import {useForm} from 'react-hook-form'
import {Answer} from 'Event/SubmissionsProvider'
import isEqual from 'lodash/isEqual'

export default function CompletedTestForm(props: {
  form: Form
  answers: Answer[]
  setAnswers: Dispatch<SetStateAction<Answer[]>>
  disabled?: boolean
}) {
  const {form, disabled, answers, setAnswers} = props
  const {control, setValue, watch} = useForm()

  const watchAnswers = watch('answers')

  useEffect(() => {
    if (!isEqual(answers, watchAnswers)) {
      setAnswers(watchAnswers)
    }
  }, [watchAnswers, answers, setAnswers])

  const checkQuestionRules = useCheckQuestionRules({watch, answers})

  return (
    <>
      {form.questions
        .filter((question) => checkQuestionRules(question))
        .map((question, index) => (
          <Question
            key={question.id}
            index={index}
            control={control}
            question={question}
            answers={answers}
            setValue={setValue}
            disabled={disabled}
            watch={watch}
          />
        ))}
    </>
  )
}
